export default [
    "30 30",
    '<path id="Icon" d="M3.75 15H26.25M3.75 7.5H26.25M11.25 22.5H26.25" fill="none" stroke="var(--p-icon-menu-color, currentColor)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>']